import { type Zone, type ParkingAssistantSettings } from 'src/api/fm/zones/zones.model'

export const SET_ZONE_OPTIONS = 'SET_ZONE_OPTIONS' as const
export const SET_ALL_ZONES = 'SET_ALL_ZONES' as const
export const FETCH_ALL_ZONES = 'FETCH_ALL_ZONES' as const
export const GET_ZONE_PARKING_ASSISTANT_SETTINGS = 'GET_ZONE_PARKING_ASSISTANT_SETTINGS' as const
export const SET_ZONE_PARKING_ASSISTANT_SETTINGS = 'SET_ZONE_PARKING_ASSISTANT_SETTINGS' as const
export const UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS = 'UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS' as const

export interface ZoneOption {
    value: string
    label: string
    currency: string
}

export interface ZoneStringOption {
    value: string
    label: string
}

export interface ZoneState {
    zoneOptions: ZoneOption[]
    allZones: Zone[]
    zoneParkingAssistantSettings: ParkingAssistantSettings | null
}
